import React, {useState, useEffect, useContext} from 'react';
import CommandsContext from '../../context/commandsContext';
import useKeyPress from '../../hooks/useKeyPress';
import FullBodyContentView from '../views/fullBodyContentView';

function Versions({onExit}) {
  const leftPress = useKeyPress('ArrowLeft');
  const {onUpdateCommands} = useContext(CommandsContext);

  useEffect(() => {
    if (!leftPress) return;
    onExit();
  }, [leftPress]);

  useEffect(() => {
    setTimeout(() => {
      onUpdateCommands({onLeft: onExit});
    });
  }, [onExit]);

  return (
    <FullBodyContentView
      title="Versions"
      fullCaption="Transmitter Software..........2.00....... 
      ETO Number......................0............
      Core Software....................4.60.......
      W&M Application..............................
      Density......................2 g/cm3........... 
      Bootloader........................................
      "
    />
  );
}

export default Versions;
